import React from 'react';
import {
    Card,
    CardContent,
    Typography,
    Box,
    Divider,
} from '@mui/material';
import {
    School as SchoolIcon,
    TipsAndUpdates as TipsIcon,
    Assessment as AssessmentIcon,
    AutoAwesome as AutoAwesomeIcon,
} from '@mui/icons-material';

const TeachingTips = () => {
    return (
        <Card>
            <CardContent>
                <Typography variant="h6" gutterBottom sx={{display: 'flex', alignItems: 'center'}}>
                    <TipsIcon sx={{mr: 1}}/>
                    Teaching Tips
                </Typography>
                <Divider sx={{mb: 2}}/>

                <Box sx={{mb: 2}}>
                    <Typography variant="subtitle2" color="primary" gutterBottom>
                        <SchoolIcon sx={{fontSize: 16, mr: 0.5, verticalAlign: 'middle'}}/>
                        Question Creation
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        Combine multiple-choice and free-text questions to improve retention and
                        understanding.
                    </Typography>
                </Box>

                <Box sx={{mb: 2}}>
                    <Typography variant="subtitle2" color="primary" gutterBottom>
                        <AutoAwesomeIcon sx={{fontSize: 16, mr: 0.5, verticalAlign: 'middle'}}/>
                        PDF Upload
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        Upload PDFs to automatically generate questions using AI. Review and edit the
                        generated questions before publishing.
                    </Typography>
                </Box>

                <Box>
                    <Typography variant="subtitle2" color="primary" gutterBottom>
                        <AssessmentIcon sx={{fontSize: 16, mr: 0.5, verticalAlign: 'middle'}}/>
                        Analytics
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        Regularly check the analytics to identify challenging questions and adapt your
                        teaching approach.
                    </Typography>
                </Box>
            </CardContent>
        </Card>
    );
};

export default TeachingTips;